import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Contact from "../components/contact";
import Hero from "../commercial/components/hero";
import TriCards from "../commercial/components/triCards";
import PageShell from "../components/pageShell";
import ZigZag from "../commercial/components/zigzag";
import BeforeAfter from "../commercial/components/beforeAfter";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const ResSoftwashPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Soft Wash & Pressure Wash - Flyby Shine</title>
                        <meta name="description" content="Elevate Your Home and Property's Appeal with Our Traditional Pressure and Soft Washing Services." />
                        <meta name="keywords" content="Soft Wash, Pressure Wash, Soft Washing Services, Pressure Washing Services, traditional pressure washing, traditional soft washing, residential pressure washing, residential soft washing, home pressure washing, home soft washing, expert pressure washing services, expert soft washing services, safe pressure washing, safe soft washing, thorough pressure washing, thorough soft washing, professional pressure washing, professional soft washing, reliable pressure washing, reliable soft washing, top-quality pressure washing, top-quality soft washing, pressure washing services, soft washing services, pressure washing solutions, soft washing solutions, pressure washing experts, soft washing experts" />
                        <meta property="og:image" content="/assets/pressurehome.png" />
                    </>
                )}
            </MetaTagHandler>

            <PageShell>
                <Hero
                    subTitle={'Residential & Home'}
                    title={'Soft Wash & Pressure Wash'}
                    description={`Elevate Your Home and Property's Appeal with Our Traditional Pressure and Soft Washing Services.`}
                    banner={{
                        video: '/assets/videos/pressurehome.mp4',
                        thumbnail: '/assets/videos/thumbnails/pressurehome.png',
                        alt: 'A drone cleaning a commercial building'
                    }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/residential-home'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Experienced Team'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'Check Mark' }}
                        description={'Our trained professionals have extensive experience in pressure and soft washing and are committed to delivering reliable, high-quality service.'}

                    />
                    <TriCards.Card
                        title={'High-Quality Equipment'}
                        heading={{ image: '/assets/equipment.svg', alt: 'equipment icon' }}
                        description={'We utilize industrial-grade sweepers and pressure washers to remove all debris, dirt, and spills, ensuring that your property remains spotless and inviting.'}
                    />
                    <TriCards.Card
                        title={'Preventative Maintenance'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'about' }}
                        description={'Regular cleaning helps to prevent deterioration caused by dirt, chemicals, and weather. '}
                    />
                </TriCards>
                <BeforeAfter
                    title={"Before And After"}
                    description={"Wash away the dirt and grime from your property with our traditional pressure and soft washing services."}
                    subTitle={"Traditional Soft Wash & Pressure Wash"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>
                                    Trained Professionals
                                </li>
                                <li><i className="material-icons">check_circle_outline</i>
                                    High-Quality Equipment
                                </li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/pressureBefore.png',
                        },
                        secondImage: {
                            imageUrl: '/assets/pressureAfter.png',
                        }

                    }
                    ]}

                />

                <ZigZag>

                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/home.mp4',
                            thumbnail: '/assets/videos/thumbnails/home.png'

                        }}
                        title={'Prevent Home Damage'}
                        heading={{ image: '/assets/star.svg', alt: 'faster bolt icon' }}
                        description={'Over time, dirt, mold, and mildew can cause significant damage to your home’s exterior, leading to costly repairs. Our drone cleaning services help protect your investment by removing harmful substances before they cause any harm.'}
                    />
                </ZigZag>
                <Contact />
            </PageShell>
            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }
                    `
                }
            </style>

        </>
    )
}

export default ResSoftwashPage
